module.exports = __webpack_public_path__ + "static/src/content/images/processed/400/leromain.09c8b42.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/content/images/processed/400/leromain.jpg
// module id = 8PMz
// module chunks = 0